<div class="flex justify-center" data-cy="bullets">
  <ng-template ngFor let-step [ngForOf]="stepOrder" let-index="index">
    <div class="app-progress-bar" [ngClass]="index <= (currentIndex$ | async) ? 'checked' : 'not-checked'"
         [attr.data-cy]="'bullets-step-' + index">
      <div class="circle"></div>
    </div>
    <div *ngIf="index !== stepOrder.length - 1" class="progress-bar-line"></div>
  </ng-template>
</div>
